export class Sound {
  public id: number;
  public name: string;
  public title: string;
  public url: string;
  public soundEffect: string;
  public soundVolume: string;
  public isSelected = false;

  constructor(id: number, name: string = '', soundEffect: string = '', isSelected: any = '') {
    this.id = id;
    this.name = name;
    this.soundEffect = soundEffect;
    this.isSelected = isSelected;
  }
}
